import { useCallback, useEffect, useState } from "react";
import { api } from "../api";
import StudentList from "../components/StudentList";
import Layout from "../components/Layout";
import { onDataChanged } from "../services/socketService";


export default function Dashboard() {

  const [classes, setClasses] = useState([]);
  const [selectedClass, setSelectedClass] = useState(null);
  const [students, setStudents] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const user = JSON.parse(localStorage.getItem("user"));

  const fetchClasses = useCallback(async () => {
    const response = await api.get("/classes");
    const filtered = response.data.filter(
      (c) => c.instructorId === user.id
    );
    setClasses(filtered);
  }, [user.id]);

  useEffect(() => {
    fetchClasses();
  }, [fetchClasses]);

  const fetchStudents = useCallback(async (classId, pageNumber = 1) => {
    const response = await api.get(
      `/students/class/${classId}?page=${pageNumber}&limit=10`
    );

    if (Array.isArray(response.data)) {
      setStudents(response.data);
      setPage(1);
      setTotalPages(1);
      return;
    }

    setStudents(response.data?.data || []);
    setPage(response.data?.page || 1);
    setTotalPages(response.data?.totalPages || 1);
  }, []);

  useEffect(() => {
    if (selectedClass) {
      fetchStudents(selectedClass, 1);
    }
  }, [selectedClass, fetchStudents]);

  useEffect(() => {
    const unsubscribe = onDataChanged(() => {
      if (selectedClass) {
        fetchStudents(selectedClass, page);
      }
    });

    return () => unsubscribe();
  }, [selectedClass, page, fetchStudents]);


return (
  <Layout>

    <div className="card shadow-sm">
      <div className="card-body">

        <h4 className="mb-4">Minhas Turmas</h4>

        <select
          className="form-select mb-4"
          value={selectedClass || ""}
          onChange={(e) => {
            const value = e.target.value;
            setSelectedClass(value ? Number(value) : null);
            setPage(1);
          }}
        >
          <option value="">Selecione a turma</option>
          {classes.map((c) => (
            <option key={c.id} value={c.id}>
              {c.name}
            </option>
          ))}
        </select>

        {selectedClass && (
          <StudentList
            students={students}
            page={page}
            totalPages={totalPages}
            onRefresh={() => fetchStudents(selectedClass, page)}
            onPageChange={(nextPage) => fetchStudents(selectedClass, nextPage)}
          />
        )}

      </div>
    </div>

  </Layout>
);

}
